export default function getLastFourDigits(string = '') {
  return string.substring(string.length - 4);
}
